import { render, staticRenderFns } from "./FormInfo.vue?vue&type=template&id=1cb7fe05&scoped=true&"
import script from "./FormInfo.vue?vue&type=script&lang=js&"
export * from "./FormInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormInfo.vue?vue&type=style&index=0&id=1cb7fe05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb7fe05",
  null
  
)

export default component.exports